var component = false;
var click = 0;

Vue.directive('modal', {
    inserted: function (el) {

        el.addEventListener('click', function (e) {

            e.preventDefault();
            click++;

            if( (browser.touch && click === 2) || !browser.touch || document.getElementById('project') )
            {
                Vue.http.get( this.getAttribute('href') )
                    .then(function(response) {

                        var project = Vue.extend({
                            template: response.body,
                            mixins: [modal]
                        });

                        if( component )
                            component.close();

                        component = new project().$mount();
                        document.getElementById('app').appendChild(component.$el);
                    });
            }
        });
    }
});

Vue.component('modal', {
    template: '#modal-template'
});

var modal = {
    data: function () {
        return {
            showModal: false
        }
    },
    methods:{
        close:function(){
            this.showModal = false;
            click = 0;
            document.body.classList.remove('has-popin')
        }
    },
    mounted: function(){
        this.showModal = true;
        document.body.classList.add('has-popin');
     }
};
